import * as React from "react";
import * as ReactDOM from "react-dom";
import { polyfill } from "es6-promise";
import { App } from "./view/app";

function renderApp() {
    ReactDOM.render(
        <App />, document.getElementById("root")
    );
}

polyfill();
renderApp();


// WEBPACK FOOTER //
// ./client/boot.tsx